import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BusList from '../../components/campus/shuttle/BusList';
import BusEdit from '../../components/campus/shuttle/BusEdit';
import BusRead from '../../components/campus/shuttle/BusRead';
import SimpleHeader from '../../components/layout/SimpleHeader';
import { IBusDetail, ILine } from '../../models/shuttleSetting.model';
import LineList from '../../components/campus/shuttle/LineList';
import LineEdit from '../../components/campus/shuttle/LineEdit';
import ScheduleList from '../../components/campus/shuttle/ScheduleList';
import ScheduleDetail from '../../components/campus/shuttle/ScheduleDetail';
import { useHistory, useLocation } from 'react-router-dom';
import QueryString from 'qs';
import useUtil from '../../hooks/useUtil';

export enum ShuttleContents {
  BusList,
  BusCreate,
  BusRead,
  BusUpdate,
  LineList,
  LineEdit,
  ScheduleList,
  ScheduleDetail
}

const CampusShuttle = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { isCampusDeactived } = useUtil();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const [content, setContent] = useState<ShuttleContents>(ShuttleContents.BusList);
  const [bus, setBus] = useState<IBusDetail>();
  const [busCode, setBusCode] = useState<number | undefined>();
  const [line, setLine] = useState<ILine>();
  const [lineCode, setLineCode] = useState<number | undefined>();
  const [campusDeactived, setCampusDeactived] = useState(false);

  useEffect(() => {
    if (query.index) {
      setContent(Number(query.index));
    } else {
      setContent(ShuttleContents.BusList);
    }
  }, [location]);

  useEffect(() => {
    setCampusDeactived(isCampusDeactived());
  }, [isCampusDeactived]);

  const renderContent = () => {
    switch (content) {
      // 차량관리 탭
      case ShuttleContents.BusList:
        return <BusList
          setBusCode={setBusCode}
          campusDeactived={campusDeactived}
        />;
      case ShuttleContents.BusCreate:
        return <BusEdit />;
      case ShuttleContents.BusRead:
        return (
          <BusRead
            bus={bus}
            setBus={setBus}
            busCode={busCode}
          />
        );
      case ShuttleContents.BusUpdate:
        return <BusEdit bus={bus} />;
      // 노선관리 탭
      case ShuttleContents.LineList:
        return (
          <LineList
            line={line}
            setLine={setLine}
            setLineCode={setLineCode}
            campusDeactived={campusDeactived}
          />
        );
      case ShuttleContents.LineEdit:
        return (
          <LineEdit
            lineCode={lineCode}
          />
        );
      case ShuttleContents.ScheduleList:
        return (
          <ScheduleList
            line={line}
          />
        );
      case ShuttleContents.ScheduleDetail:
        return (
          <ScheduleDetail />
        );
    }
  }

  return (
    <>
    <div className="content scrollbar">
      <SimpleHeader
        iconFile="icon-campus-big.png"
        parentMenu={t('common.menu.campus')}
        currentMenu={t('campus.shuttle.title1')}
        onlyTitle={true}
      />
      <div className="comm-tab__line">
        <ul>
          <li className={(
                content === ShuttleContents.BusList ||
                content === ShuttleContents.BusCreate ||
                content === ShuttleContents.BusRead ||
                content === ShuttleContents.BusUpdate
                  ? ' active'
                  : ''
              )}>
            <a
              className="btn-item"
              onClick={() => history.push(`/campus/shuttle?index=${ShuttleContents.BusList}`)}
            >
              {t('campus.shuttle.tap1')}
            </a>
          </li>
          <li className={(
                content === ShuttleContents.LineList ||
                content === ShuttleContents.LineEdit ||
                content === ShuttleContents.ScheduleList ||
                content === ShuttleContents.ScheduleDetail
                  ? ' active'
                  : ''
              )}>
            <a
              className="btn-item"
              onClick={() => history.push(`/campus/shuttle?index=${ShuttleContents.LineList}`)}
            >
              {t('campus.shuttle.tap2')}
            </a>
          </li>
        </ul>
      </div>
      <div className="tab-content" id="custom-tabs-tabContent">
        {renderContent()}
      </div>
    </div>
    </>
  )
}

export default CampusShuttle;
